import { Link } from 'react-router'

import { Post } from '../scripts/types'

interface Props {
  post: Post
}

const PostItem = ({ post }: Props) => {
  return (
    <article className='p-6 bg-gray-800 rounded-lg border border-gray-700 shadow-md'>
      <div className='flex justify-between items-center mb-5 text-gray-500'>
        <div>
          {post.data.tags.map(tag => (
            <span
              key={tag}
              className='bg-primary-100 text-primary-800 text-xs font-medium inline-flex items-center px-2.5 py-0.5 rounded dark:bg-primary-200 dark:text-primary-800'
            >
              {tag}
            </span>
          ))}
        </div>
        <span className='text-sm whitespace-nowrap'>{post.data.created}</span>
      </div>
      <h2 className='mb-2 text-2xl font-bold tracking-tight text-white'>
        <Link to={`/posts/${post.slug}`}>{post.data.title}</Link>
      </h2>
      <p className='mb-5 font-light text-gray-300'>{post.data.excerpt}</p>
      <div className='flex justify-between items-center'>
        <Link to={`/posts/${post.slug}`} className='inline-flex items-center font-medium text-blue-400 hover:underline'>
          Read more
          <svg className='ml-2 w-4 h-4' fill='currentColor' viewBox='0 0 20 20' xmlns='http://www.w3.org/2000/svg'>
            <path
              fillRule='evenodd'
              d='M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z'
              clipRule='evenodd'
            ></path>
          </svg>
        </Link>
      </div>
    </article>
  )
}

export default PostItem
